module.exports = __webpack_public_path__ + "img/public_popup_head_delete.27f9af60.svg";